import { useEffect, useState } from 'react'
import API from '../../../services/API'

// Display labels for the CQC regulated activities a risk can relate to -
// mirrors pages/registration/Activities/ActivitiesList.jsx.
export const CQC_ACTIVITY_LABEL = {
  treatment_of_disease_disorder_injury:
    'Treatment of disease, disorder or injury (TDDI)',
  transport_services_triage_medical_advice:
    'Transport services, triage and medical advice',
}

export const CQC_ACTIVITY_SHORT_LABEL = {
  treatment_of_disease_disorder_injury: 'TDDI',
  transport_services_triage_medical_advice: 'Transport & triage',
}

// The default quality statements the CQC engine maps every risk to when no
// specific statements are chosen (helpers/cqcCentre/modules/riskRegister.js).
export const DEFAULT_RISK_STATEMENT_KEYS = [
  'safe-involving-people-manage-risks',
  'responsive-planning-for-the-future',
]

// The CQC quality-statement framework lives server-side as versioned code;
// the settings endpoint returns it (with tenant overrides applied) under the
// same Governance guard as the risk register itself.
export const useCqcStatements = () => {
  const [statements, setStatements] = useState([])
  const [keyQuestions, setKeyQuestions] = useState([])

  useEffect(() => {
    API.get('/cqc-centre/settings')
      .then((res) => {
        if (res.status === 200) {
          setStatements(res.data.qualityStatements ?? [])
          setKeyQuestions(res.data.keyQuestions ?? [])
        }
      })
      .catch((e) => console.log(e))
  }, [])

  return { statements, keyQuestions }
}

export const statementTitle = (key, statements) =>
  statements.find((qs) => qs.key === key)?.title ?? key

export const keyQuestionForStatement = (key, statements) =>
  statements.find((qs) => qs.key === key)?.keyQuestion
